import React, { useEffect, useState } from "react";
import BasicEngineLog from "./child/basic-engine";
import MainEngineLog from "./child/main-engine";
import AuxiliryEngineLog from "./child/auxiliry-engine";
import AuxilaryRemarksLog from "./child/auxilary-remarks";
import VoyageDetails from "../../../components/VoyageDetails";
import SubTabMachinary from "./child/SubMachinaryTab";
import { useParams } from "react-router-dom";
import { SubTabCargoMachin } from "./child/SubTabCargoMachin";

function EditEngineLogBook() {
  const [activeTab, setActiveTab] = useState("basic");
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  useEffect(() => {
    const lastSelectedKey = localStorage.getItem("engineLogbook") || activeTab;
    setActiveTab(lastSelectedKey);
  }, []);

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
  }, []);
  const { eng_log_basic_id } = useParams();

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <ul className="marine-tabs">
          <li
            className={activeTab === "basic" ? "active" : ""}
            onClick={() => handleClick("basic")}
          >
            Basic Engine Log
          </li>

          <li className={activeTab === "main" ? "active" : ""} onClick={() => handleClick("main")}>
            Main Engine Log
          </li>
          <li
            className={activeTab === "auxiliary" ? "active" : ""}
            onClick={() => handleClick("auxiliary")}
          >
            Auxiliary Engine Log
          </li>
          <li
            className={activeTab === "auxiliary machinery" ? "active" : ""}
            onClick={() => handleClick("auxiliary machinery")}
          >
            Auxiliary Machinery
          </li>
          <li
            className={activeTab === "Cargo Machinery" ? "active" : ""}
            onClick={() => handleClick("Cargo Machinery")}
          >
            Cargo Machinery
          </li>
          <li
            className={activeTab === "remarks" ? "active" : ""}
            onClick={() => handleClick("remarks")}
          >
            Remarks
          </li>
        </ul>
        {activeTab == "basic" && <BasicEngineLog />}
        {activeTab == "main" && <MainEngineLog />}
        {activeTab == "auxiliary" && <AuxiliryEngineLog />}
        {activeTab == "auxiliary machinery" && <SubTabMachinary id={eng_log_basic_id} />}
        {activeTab == "Cargo Machinery" && <SubTabCargoMachin id={eng_log_basic_id} />}
        {activeTab == "remarks" && <AuxilaryRemarksLog />}
      </div>
    </>
  );
}

export default EditEngineLogBook;
